module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/facebook-dark-064b42f34d8581ee73bc9ce5d8d40fbc.svg";